import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV, faTimes } from '@fortawesome/free-solid-svg-icons';
import { HashLink } from 'react-router-hash-link';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';

const Navigation = () => {
  const [icon, setIcon] = useState(faEllipsisV);

  return (
    <>
      <Navbar bg='dark' variant='dark' expand='lg' className='navbar'>
        <Navbar.Toggle
          aria-controls='basic-navbar-nav'
          onClick={() => setIcon(icon === faEllipsisV ? faTimes : faEllipsisV)}
        >
          <FontAwesomeIcon icon={icon} size='1x' className='icon' />
        </Navbar.Toggle>
        <Navbar.Collapse id='basic-navbar-nav'>
          <Nav as='ul' className='ml-auto navbar-nav'>
            <Nav.Link as='li'>
              <HashLink to='/#home' className='link'>
                Start
              </HashLink>
            </Nav.Link>
            <Nav.Link as='li'>
              <HashLink to='/#about' className='link'>
                Über mich
              </HashLink>
            </Nav.Link>
            <Nav.Link as='li'>
              <HashLink to='/#forms' className='link'>
                Formulare
              </HashLink>
            </Nav.Link>
            <Nav.Link as='li'>
              <HashLink to='/#activity' className='link'>
                Tätigkeitsfelder
              </HashLink>
            </Nav.Link>
            <Nav.Link as='li'>
              <HashLink to='/#notaries' className='link'>
                Notarin
              </HashLink>
            </Nav.Link>
            {/*<Nav.Link as='li'>*/}
            {/*  <HashLink to='/#jobDescriptions' className='link'>*/}
            {/*    Stellenangebote*/}
            {/*  </HashLink>*/}
            {/*</Nav.Link>*/}
            <Nav.Link as='li'>
              <HashLink to='/#contact' className='link'>
                Kontakt
              </HashLink>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
};

export default Navigation;
